import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  to?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  to,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-forest disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-gold text-forest hover:bg-[#b39249] shadow-sm',
    secondary: 'bg-forest text-cream hover:bg-[#152d23] shadow-sm',
    outline: 'border-2 border-forest text-forest hover:bg-forest hover:text-cream',
    ghost: 'text-forest hover:bg-forest/5'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-193">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-194">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-195">
      {children}
    </button>;
}